import React from 'react'

import { withRouter } from 'react-router-dom'

import { Container, Tab } from 'semantic-ui-react';

import {
  PaneInformations,
  PaneUsers,
  PaneHorses,
  PaneExamens,
  PaneInvoices
} from './panes';

import { BreadcrumbHelper } from 'utils';

class ClinicScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleModelChange = this.handleModelChange.bind(this);

    let panes = [];

    panes.push({
      menuItem: {
        content: 'Informations',
        icon: 'info'
      },
      render: () => {

        const { clinic } = this.state;
        const { devices } = this.props;

        return <PaneInformations clinic={clinic} devices={devices} onModelChange={this.handleModelChange} />
      }
    });

    //Pane Veterinaries
    panes.push({
      id: 'users',
      menuItem: {
        content: 'Vétérinaires',
        icon: 'users'
      },
      render: () => {

        const { clinic } = this.state;

        return <PaneUsers clinic={clinic} />
      }
    });

    //Pane Veterinaries
    panes.push({
      id: 'horses',
      menuItem: {
        content: 'Chevaux'
      },
      render: () => {

        const { clinic } = this.state;

        return <PaneHorses clinic={clinic} />
      }
    });

    //Pane Veterinaries
    panes.push({
      id: 'examens',
      menuItem: {
        content: 'Examens'
      },
      render: () => {

        const { clinic } = this.state;

        return <PaneExamens clinic={clinic} />
      }
    });

    //Pane Veterinaries
    panes.push({
      id: 'invoices',
      menuItem: {
        content: 'Factures'
      },
      render: () => {

        const { clinic, invoices } = this.state;

        return <PaneInvoices clinic={clinic} invoices={invoices} />
      }
    });
    

    //Select active tab based on hash
    let hash = window.location.hash.trim().substring(1);
    let activeIndex = hash.length > 0 ? null : 0;

    if (!activeIndex) {

      for(let i = 0; i < panes.length; i++) {

        if(panes[i].id === hash) {
          activeIndex = i;
          break;
        }
      }

      //Unknown hash
      if(!activeIndex) {
        activeIndex = 0;
        window.location.hash = '';
      }
    }

    const { clinic } = this.props;

    this.state = {
      clinic: clinic,
      panes: panes,
      activeIndex: activeIndex
    };

    this.updateBreadcrumb();
  }

  updateBreadcrumb() {

    const { clinic } = this.props;

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Cliniques', '/clinics');
    BreadcrumbHelper.push(clinic.name);

    //Active pane
    let pane = this.state.panes[this.state.activeIndex];
    BreadcrumbHelper.push(pane.menuItem.content);

    BreadcrumbHelper.flush();
  }

  handleTabChange(e, { activeIndex }) {

    this.setState({ activeIndex }, this.updateBreadcrumb);

    //Update location hash
    let pane = this.state.panes[activeIndex];
    window.location.hash = pane.id ?? '';
  }

  handleModelChange(update) {

    let clinic = { ...this.state.clinic, ...update };

    //Update
    this.setState({
      clinic: clinic
    }, this.updateBreadcrumb);
  }

  render() {

    const { panes, activeIndex } = this.state;

    return (
      <React.Fragment>

        <Container>
          <Tab
            id="tabs"
            panes={panes}
            activeIndex={activeIndex}
            menu={{ secondary: false, pointing: true }}
            onTabChange={this.handleTabChange} />
        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(ClinicScene);
